import React from "react";

export interface ArrowMarkerProps {
  id?: string;
  className?: string;
  xOffset?: number;
}

export const ArrowMarker = ({ id = "arrow", className = "", xOffset = 8.5 }: ArrowMarkerProps) => {
  return (
    <marker
      id={id}
      className={className}
      viewBox="0 0 10 10"
      refX={xOffset}
      refY="4.5"
      markerWidth="11"
      markerHeight="11"
      orient="auto-start-reverse"
    >
      <path d="M 0 0 L 10 4.5 L 0 9.5 L 2.5 4.5 Z" />
    </marker>
  );
};
